
PHI.util = {};

PHI.util.hover = {
  icon: null,
  target: null,
  active: null,

  registerElement: function(icon, target) {
    /* eslint-disable dollar-sign/dollar-sign */
    this.icon = $(icon);
    this.target = $(target);
    /* eslint-enable dollar-sign/dollar-sign */
    $(icon).on('mouseenter', this.showElement.bind(this));
  },

  showElement: function() {
    this.target.addClass('show');
  }

};

